import { InputChangeEventArgs as InputChangeEventArgs_internal } from "./InputChangeEventArgs";
import { ensureBool } from "igniteui-react-core";
var IgrInputChangeEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrInputChangeEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrInputChangeEventArgs.prototype.createImplementation = function () {
        return new InputChangeEventArgs_internal();
    };
    Object.defineProperty(IgrInputChangeEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrInputChangeEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrInputChangeEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrInputChangeEventArgs.prototype, "value", {
        get: function () {
            return this.i.value;
        },
        set: function (v) {
            this.i.value = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrInputChangeEventArgs.prototype, "isCompositionInProgress", {
        get: function () {
            return this.i.isCompositionInProgress;
        },
        set: function (v) {
            this.i.isCompositionInProgress = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    return IgrInputChangeEventArgs;
}());
export { IgrInputChangeEventArgs };
//# sourceMappingURL=igr-input-change-event-args.js.map
